import React from 'react';
import { MessageCircle } from 'lucide-react';
import { GYM_INFO } from '../mock';

const WhatsAppFloat = () => {
  return (
    <a
      href={`${GYM_INFO.whatsappLink}?text=Hi, I'm interested in Iron Crust Gym!`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 group"
    >
      <div className="relative">
        {/* Pulsing ring effect */}
        <div className="absolute inset-0 bg-[#39FF14] rounded-full animate-ping opacity-30" />
        
        {/* Main button */}
        <div className="relative bg-[#39FF14] p-4 rounded-full shadow-2xl shadow-[#39FF14]/50 hover:scale-110 transition-transform duration-300">
          <MessageCircle className="w-7 h-7 text-black" />
        </div>

        {/* Tooltip */}
        <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-black text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-xl border border-[#39FF14]/30">
            Chat on WhatsApp
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
              <div className="border-8 border-transparent border-l-black" />
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppFloat;
